const keys = {
    UserNameOauth: 'UserNameOauth',
    PasswordOauth: 'PasswordOauth',
    ClientId: 'client_id',
    BenefitId: 'benefitId',
    ProductsFilter: 'productsFilter',
    ePharmaAuthenticationService: 'ePharma.Authentication.Service',
    EndpointAuthenticationAuth: 'Endpoint.Authentication.Auth',
    ePharmaCommonService: 'ePharma.Common.Service',
    EndpointCommonState: 'Endpoint.Common.StateRead',
    EndpointCommonCity: 'Endpoint.Common.City',
    EndpointCommonPrescriber: 'Endpoint.Common.Prescriber',
    ePharmaChainService: 'ePharma.Chain.Service',
    EndpointChainStore: 'Endpoint.Chain.Store',
    EndpointChainNeighborhood: 'Endpoint.Chain.Neighborhood',
    EndpointMomentaMaisVerifyCoupon: 'Endpoint.MomentaMais.VerifyCoupon',
    EndPointMomentaMaisBeneficiaryCupom: 'EndPoint.Beneficiary.Cupom',
    EndpointMomentaMaisGenerateCoupon: 'Endpoint.MomentaMais.GenerateCoupon',
    EndPointBeneficiaryEditCupom: 'EndPoint.Beneficiary.EditCupom',
    EndPointMomentaMaisProduct: 'EndPoint.MomentaMais.Product',
    ePharmaBeneficiaryService: 'ePharma.Beneficiary.Service',
    EndpointBeneficiaryBeneficiary: 'Endpoint.Beneficiary.Beneficiary',
    EndPointBeneficiaryFindBeneficiary: 'EndPoint.Beneficiary.FindBeneficiary',
    EndpointMomentaMaisBenefit: 'Endpoint.MomentaMais.Benefit',
    EndpointMomentaMaisPerson: 'Endpoint.MomentaMais.Person'
};

export default keys;